import { Link, useNavigate } from 'react-router-dom';
import { navigateMorph } from '../lib/transition';
import './hoodad.css';

const FEATURES = [
  ['🏦', 'Rob the State Bank', 'Lasers, guards and a $50,000 treasury.'],
  ['✈️', 'Fly to Egypt', 'Pyramids, camels, crocodiles and a whole sand city.'],
  ['📱', 'Your own phone', 'Text players and post on Hoodgram.'],
  ['🎢', 'Neon Funfair', 'Ghost train, rollercoaster and Ferris wheel.'],
];

/** An advertisement for Life in the Hood on the chess home page: a night skyline with a police chase, the pitch and a play button. */
export function HoodAd() {
  const nav = useNavigate();
  return (
    <section className="hood-ad" aria-label="Life in the Hood">
      <div className="ad-sky" aria-hidden="true">
        <i className="ad-moon" />
        <span className="ad-skyline" />
        <span className="ad-road"><i className="ad-car" /><i className="ad-cop" /></span>
        <span className="ad-stars">★★★</span>
      </div>
      <div className="ad-body">
        <span className="ad-tag">NEW · FREE · ONLINE</span>
        <h2><span>LIFE IN</span><b>THE HOOD</b></h2>
        <p className="ad-lead">An open-world crime sandbox in your browser. Rob, race, fly and explore a city of 600 buildings together with other players.</p>
        <ul className="ad-feats">
          {FEATURES.map(([ic, t, d]) => <li key={t}><span>{ic}</span><b>{t}</b><em>{d}</em></li>)}
        </ul>
        <Link to="/hood" className="ad-cta" onClick={(e) => { e.preventDefault(); navigateMorph(nav, '/hood', e.currentTarget, 'page'); }}>▶ Play Life in the Hood</Link>
      </div>
    </section>
  );
}
